import { BANK_MAP } from '@/model/card'
import { defineStore } from 'pinia'
import { useAppStore, useProcessStore } from '@/store'
import { getCardBindStatus, hasIdNo, hasPayPwd } from '@/api/user'

export const useCardStore = defineStore({
  id: 'card',
  state: (): CardState => ({
    // hadSetPwd: false,
    hadRealNameAuth: false,
    hadBindCard: false,

    bindingSessionId: '',
    thirdDSOrderId: '',
    thirdDSRedirectHtml: '',
    thirdDSState: '',

    cardId: '', // 卡id
    cardNo: '', // 卡号
    cardLast4No: '',
    cardType: '', // 卡类型
    cardName: '', // 卡名称
    icon: '', // 卡icon
    icon4Detail: '',
  }),
  getters: {
    getCardIcon(): string {
      let iconDetail = this.icon4Detail

      if (!iconDetail) {
        return 'https://mpay.icbc.com.mo:11443/img/defaultIcon2x.png'
      }

      // 如果icon路径包含admin 则说明该卡存在维护卡Bin 需要用卡Bin的大尺寸图标
      if (iconDetail.includes('/admin/') && !iconDetail.includes('/admin/iconDetail/')) {
        iconDetail = iconDetail.replace('/admin/', '/admin/iconDetail/')
      }

      return iconDetail
    },

    getCardName(): string {
      return this.cardName || '銀行卡'
    },

    getCardLast4No(): string {
      return this.cardNo.substring(this.cardNo.length - 4)
    },
  },
  actions: {
    /**
     * 格式化卡号码
     * @param last4No - 卡的后四位号码
     * @example
     * @returns
     */
    formatCardNo(last4No: string) {
      return last4No.substring(last4No.length - 4)
    },
    /** 设置卡类型 */
    setCardType() {
      const bankNo = useProcessStore().params.bankNo
      this.cardType = BANK_MAP.get(bankNo)?.getCardType(this.cardNo) || ''
    },
    /** 是否设置了支付密码 */
    hasSetPwd() {
      return new Promise(async (resolve) => {
        const res = await hasPayPwd()
        const hadSetPwd: boolean = res?.result === '0'
        useAppStore().hadSetPwd = hadSetPwd
        resolve(hadSetPwd)
      })
    },
    /** 是否实名认证 */
    hasRealNameAuth() {
      return new Promise(async (resolve) => {
        const res = await hasIdNo()
        const hadRealNameAuth = res?.result === '0'
        resolve(hadRealNameAuth)
      })
    },
    /** 是否绑定了卡 */
    hasBindCard() {
      return new Promise(async (resolve) => {
        const res = await getCardBindStatus()
        const hadBindCard: boolean = res?.result === '0'
        resolve(hadBindCard)
      })
    },
  },
  persist: {
    enabled: true,
    // strategies: [
    //   {
    //     key: 'my_users',
    //     storage: localStorage,
    //   },
    // ],
  },
})
